import { createFileRoute } from '@tanstack/react-router'
import { supplierProfileSearchSchema } from '../../../../features/suppliers/search'
import { SupplierDetailPage } from '../../../../features/suppliers/supplier-detail-page'

export const Route = createFileRoute('/_app/suppliers/$supplierId/')({
  validateSearch: supplierProfileSearchSchema,
  component: SupplierDetailPage,
})
